export default __webpack_public_path__ + "static/media/calendarIconHC.5b9b02f9.svg";